import { DateInput, FormInput, Grid } from '@kirz/mui-admin';
import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

export default function Step() {
  /**
   * Validate against pattern: YY.MM.DD-xxx.yy
   * MM: 01–12, DD: 01–31
   */
  const validate = (val: string): boolean => {
    const pattern =
      /^(?:\d{2})\.(0[1-9]|1[0-2])\.(0[1-9]|[12]\d|3[01])-[0-9]{3}\.[0-9]{2}$/;
    return pattern.test(val) && val.length === 15;
  };

  return (
    <StepWrapper
      name="Rijksregister"
      description={`Typ hieronder uw rijksregisternummer (indien correct druk op "volgende")`}
    >
      <Grid container spacing={4}>
        <FormInput
          name="rijksregister"
          label="Rijksregisternummer"
          xs={12}
          sm={6}
          placeholder="YY.MM.DD-xxx.yy"
          required
          rules={{
            validate: (val: string) => {
              if (!validate(val)) {
                return 'Het formaat moet YY.MM.DD-xxx.jj zijn (MM 01–12, DD 01–31)';
              }
              return true;
            },
          }}
          InputProps={{
            inputComponent: MaskedRijksInput as any,
            inputProps: {
              onAccept: (val: string) => {
                console.log(val);
              },
            },
          }}
        />
        <DateInput
          name="id_kaart_geldig_tot"
          label="Identiteitskaart geldig tot"
          xs={12}
          sm={6}
          required
        />
        <FilesField
          name="id_kaart_documenten"
          title="Upload hier een kopie van uw identiteitskaart"
          xs={12}
          md={12}
        />
      </Grid>
    </StepWrapper>
  );
}

const MaskedRijksInput = forwardRef<HTMLElement, any>(function MaskedRijksInput(
  props,
  ref,
) {
  const { onAccept, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="00.00.00-000.00"
      definitions={{ '0': /\d/ }}
      inputRef={ref}
      onAccept={(val: string) => {
        other.onChange({
          target: {
            name: other.name,
            value: val,
          },
        });
      }}
      overwrite
    />
  );
});
